import { ClrCommonStrings } from "@clr/angular";

export const English: Partial<ClrCommonStrings> = {
    showColumns:'Show Columns',
    selectAll:'Select all',
    pickColumns:'Manage columns',
  };